/* SparesCzar search page: web products from CzarSearch AI.
 *
 * A search with no SparesCzar Ecom match loads these automatically; a search with
 * matches offers them behind a button. The resolver response is cached in
 * sessionStorage under the key sparesczar-czarsearch.js reads, so opening a product
 * in CzarSearch AI reuses this search instead of running and logging it twice. */
(function () {
  var EDGE_FN = 'https://tfaijhrbvrakrldxfqxv.supabase.co/functions/v1/czarsearch';
  var CACHE_PREFIX = 'scz-edge:';
  var CACHE_TTL_MS = 15 * 60 * 1000; // same as sparesczar-czarsearch.js
  var MAX_TILES = 12;
  var TIMEOUT_MS = 45000;
  // Pricing lives in the resolver; this matches the CzarSearch page's fallback for rows without it.
  var FALLBACK_MARKUP = 1.25;
  var BOT_RE = /bot|crawl|spider|slurp|headless|lighthouse|preview|facebookexternalhit/i;

  var TRUST = [
    ['sparesczar', 'SparesCzar trusted'], ['sparesbazaar', 'SparesCzar trusted'], ['spares bazaar', 'SparesCzar trusted'],
    ['ebay', 'High availability'], ['amazon', 'High availability'], ['walmart', 'High availability']
  ];

  var GEO_EUROPE = ['gb','de','fr','it','es','nl','be','at','ch','se','no','dk','fi','ie','pt','pl','cz','ro','hu','gr','bg','hr','sk','si','lt','lv','ee','lu','mt','cy'];
  var GEO_MIDDLE_EAST_AFRICA = ['tr','ae','sa','qa','kw','om','bh','iq','jo','lb','sy','ye','ir','ps','za','ng','ke','eg','gh','tz','ug','et','dz','ma','tn','ly','sn','cm','ci','cd','mz','zw','bw','rw','ao'];

  // Same regions as the CzarSearch page, so both pages send the resolver the same request.
  function searchRegion() {
    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve('us'); }, 1500); });
    var lookup = fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cc = String((d && d.country_code) || 'us').toLowerCase();
        if (GEO_MIDDLE_EAST_AFRICA.indexOf(cc) !== -1) return 'ae';
        if (GEO_EUROPE.indexOf(cc) !== -1 || cc === 'au' || cc === 'nz') return cc;
        return 'us';
      })
      .catch(function () { return 'us'; });
    return Promise.race([lookup, timeout]);
  }

  function cacheKey(query) { return CACHE_PREFIX + query.trim().toLowerCase(); }

  function writeCache(query, data) {
    try { sessionStorage.setItem(cacheKey(query), JSON.stringify({ t: Date.now(), data: data })); } catch (e) {}
  }

  // Coming back from CzarSearch AI (or reloading) shouldn't run the same search again.
  function readCache(query) {
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey(query)) || 'null');
      return cached && Date.now() - cached.t < CACHE_TTL_MS ? cached.data : null;
    } catch (e) {
      return null;
    }
  }

  function fetchEdge(query) {
    var cached = readCache(query);
    if (cached) return Promise.resolve(cached);
    var testRun = new URLSearchParams(window.location.search).get('scz_test') === '1';
    return searchRegion().then(function (region) {
      var controller = 'AbortController' in window ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
      return fetch(EDGE_FN, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          query: query,
          raw_query: query,
          channel: 'shopify',
          // dev_test keeps QA runs out of the demand views.
          entry_point: testRun ? 'dev_test' : 'shopify_search_page',
          mode: 'live',
          external_thread_id: 'shopify-search:' + Date.now(),
          customer_identifier: 'web-visitor',
          customer_email: '',
          customer_phone: '',
          country_code: region.toUpperCase(),
          language_code: 'en'
        })
      }).then(function (res) {
        if (timer) clearTimeout(timer);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      }).then(function (data) {
        writeCache(query, data);
        return data;
      });
    });
  }

  function parsePrice(value) {
    var n = parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return isFinite(n) && n > 0 ? n : null;
  }

  function customerPrice(item) {
    var resolved = Number(item.customer_price_value);
    if (isFinite(resolved) && resolved > 0) return resolved;
    var raw = parsePrice(item.price);
    return raw !== null ? Math.round(raw * FALLBACK_MARKUP * 100) / 100 : null;
  }

  function trustLabel(item) {
    var source = ((item.marketplace || '') + ' ' + (item.seller || '')).toLowerCase();
    for (var i = 0; i < TRUST.length; i++) {
      if (source.indexOf(TRUST[i][0]) !== -1) return TRUST[i][1];
    }
    return 'Verified supplier';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function buildTile(item, href) {
    var li = el('li', 'scz-web-tile');
    var link = el('a', 'scz-web-tile__link');
    link.href = href;

    var media = el('span', 'scz-web-tile__media');
    if (item.thumbnail) {
      var img = document.createElement('img');
      img.src = item.thumbnail;
      img.alt = '';
      img.loading = 'lazy';
      img.onerror = function () { media.classList.add('is-empty'); img.remove(); };
      media.appendChild(img);
    } else {
      media.classList.add('is-empty');
    }

    var meta = el('span', 'scz-web-tile__meta');
    meta.appendChild(el('span', '', item.condition || 'Sourced'));
    meta.appendChild(el('span', '', trustLabel(item)));

    var price = customerPrice(item);
    var priceText = price !== null
      ? '$' + price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : 'Price on request';

    link.appendChild(media);
    link.appendChild(meta);
    link.appendChild(el('span', 'scz-web-tile__title', item.title));
    link.appendChild(el('span', 'scz-web-tile__price' + (price === null ? ' is-quote' : ''), priceText));
    link.appendChild(el('span', 'scz-web-tile__cta', price === null ? 'Get a quote →' : 'View & buy →'));
    li.appendChild(link);
    return li;
  }

  function showFallback(section) {
    section.setAttribute('data-state', 'empty');
    var fallback = section.querySelector('[data-scz-web-fallback]');
    if (fallback) {
      fallback.hidden = false;
      section.classList.add('is-fallback');
    } else {
      var status = section.querySelector('[data-scz-web-status-text]');
      if (status) status.textContent = 'CzarSearch AI could not find more matches right now.';
      var grid = section.querySelector('[data-scz-web-grid]');
      if (grid) grid.hidden = true;
    }
  }

  function load(section) {
    if (section.hasAttribute('data-state')) return;
    section.setAttribute('data-state', 'loading');

    var query = section.getAttribute('data-query') || '';
    var status = section.querySelector('[data-scz-web-status]');
    var statusText = section.querySelector('[data-scz-web-status-text]');
    var grid = section.querySelector('[data-scz-web-grid]');
    var foot = section.querySelector('[data-scz-web-foot]');
    var button = section.querySelector('[data-scz-web-load]');
    if (button) button.hidden = true;
    if (status) status.hidden = false;
    if (grid) { grid.hidden = false; grid.setAttribute('aria-busy', 'true'); }

    var slow = setTimeout(function () {
      if (statusText) statusText.textContent = 'Still searching: comparing prices across verified suppliers…';
    }, 8000);

    fetchEdge(query).then(function (data) {
      clearTimeout(slow);
      var items = (data && data.shopping || []).filter(function (item) { return item && item.title; });
      if (!items.length) return showFallback(section);

      // Priced parts first, resolver order otherwise.
      items = items.map(function (item, i) { return { item: item, i: i, priced: customerPrice(item) !== null }; })
        .sort(function (a, b) { return (b.priced - a.priced) || (a.i - b.i); })
        .map(function (entry) { return entry.item; });

      var href = '/pages/czar-search?q=' + encodeURIComponent(query);
      grid.innerHTML = '';
      items.slice(0, MAX_TILES).forEach(function (item) { grid.appendChild(buildTile(item, href)); });
      grid.removeAttribute('aria-busy');
      if (status) status.hidden = true;
      if (foot) foot.hidden = false;
      section.setAttribute('data-state', 'ready');
    }).catch(function (err) {
      clearTimeout(slow);
      console.warn('CzarSearch web results failed:', err);
      showFallback(section);
    });
  }

  function init() {
    var testRun = new URLSearchParams(window.location.search).get('scz_test') === '1';
    var isBot = !testRun && (BOT_RE.test(navigator.userAgent) || navigator.webdriver === true);
    document.querySelectorAll('[data-scz-web]').forEach(function (section) {
      var button = section.querySelector('[data-scz-web-load]');
      if (button) button.addEventListener('click', function () { load(section); });
      // Crawlers render /search too; don't spend a paid lookup (or log demand) for them.
      if (section.hasAttribute('data-autoload')) {
        if (isBot) showFallback(section);
        else load(section);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
